import camelCase from 'lodash/camelCase';
import sum from 'lodash/sum';
import upperFirst from 'lodash/upperFirst';
import { bool, func } from 'prop-types';
import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';

import CurrencyFormat from '../../generic/CurrencyFormat';
import CurrencyInput from '../../generic/CurrencyInput';
import { hasLowerCase } from '../utils/utils';
import CloneConfirmation from './CloneConfirmation';

const revenueTypes = [
  'Media Managed',
  'Media Self Service',
  'Creative',
  'CI',
  'Other',
];

const ExpectedRevenuesModal = ({ open, toggleModal, onClick }) => {
  const [expectedRevenue, setExpectedRevenue] = useState(0);
  const [expectedRevenueFields, setExpectedRevenueFields] = useState({
    expectedRevenue: 0,
    expectedRevenueMediaManaged: 0,
    expectedRevenueMediaSelfService: 0,
    expectedRevenueCreative: 0,
    expectedRevenueCI: 0,
    expectedRevenueOther: 0,
  });

  const [toggle, setToggle] = useState(false);
  const toggleConfirmation = () => setToggle(!toggle);

  const handleRevenueChange = e => {
    setExpectedRevenueFields(prevState => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleCloneRequest = () => {
    onClick({
      expectedRevenueFields: {
        expectedRevenue,
        expectedRevenueSubFields: expectedRevenueFields,
      },
    });
  };

  useEffect(() => {
    const totalRevenue = sum(Object.values(expectedRevenueFields));
    setExpectedRevenue(totalRevenue);
  }, [expectedRevenueFields]);

  return (
    <>
      <CloneConfirmation
        toggle={toggle}
        setToggle={toggleConfirmation}
        onClick={handleCloneRequest}
      />

      <Modal isOpen={open} toggle={toggleModal} size="md">
        <>
          <ModalHeader toggle={toggleModal}>
            Please enter the values for expected revenues in the cloned
            opportunity
          </ModalHeader>
          <ModalBody>
            <FormGroup row>
              <Label sm={4} for="op-expectedRevenue" className="pl-5 required">
                Expected Revenue
              </Label>
              <Col sm={8}>
                <CurrencyFormat
                  id="op-expectedRevenue"
                  className="form-control-plaintext"
                  name="expectedRevenue"
                  value={expectedRevenue}
                  text
                />
              </Col>
              <Col sm={12}>
                {revenueTypes.map(type => {
                  const fieldName = hasLowerCase(type)
                    ? `expectedRevenue${upperFirst(camelCase(type))}`
                    : `expectedRevenue${type}`;
                  return (
                    <Row className="mb-3" key={type}>
                      <Label
                        sm={4}
                        for={`op-${fieldName}`}
                        className="pl-5 required"
                      >
                        {type}
                      </Label>
                      <Col sm={8}>
                        <CurrencyInput
                          id={`op-${fieldName}`}
                          name={fieldName}
                          value={expectedRevenueFields[fieldName]}
                          onChange={handleRevenueChange}
                        />
                      </Col>
                    </Row>
                  );
                })}
              </Col>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={toggleConfirmation}>
              Save
            </Button>
            <Button onClick={toggleModal} color="primary" outline>
              Cancel
            </Button>
          </ModalFooter>
        </>
      </Modal>
    </>
  );
};

ExpectedRevenuesModal.propTypes = {
  open: bool.isRequired,
  toggleModal: func.isRequired,
  onClick: func.isRequired,
};

export default ExpectedRevenuesModal;
